module.exports = __webpack_public_path__ + "img/sso_register.b8a8edbe.png";